


























































import Toast from '@/shared/services/toast';
import { LOAD_FLOWS } from '@/store/bot-designer/actionTypes';
import { LOAD_ANSWERS } from '@/store/answers/actionTypes';
import { DELETE_INTENT } from '@/store/intents/actionTypes';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { AnswerListItemViewModel } from '../../models/answers/answerListItemViewModel';
import { FlowListItemViewModel } from '../../models/flowListItemViewModel';
import { IntentListItemViewModel, IntentReferenceViewModel } from '../../models/intents/intentListItemViewModel';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';

@Component({
	components: {
		LoadingSpinner
	}
})
export default class DeleteIntentModal extends Vue {
	@Prop() public intent: IntentListItemViewModel;

	@Action(LOAD_FLOWS) public loadFlows!: (forceLoad?: boolean) => Promise<FlowListItemViewModel[]>;
	@Action(LOAD_ANSWERS) public loadAnswers!: (forceLoad?: boolean) => Promise<AnswerListItemViewModel[]>;
	@Action(DELETE_INTENT) public deleteIntent: (intentId: string) => Promise<void>;

	public flows: FlowListItemViewModel[] = [];

	public answers: AnswerListItemViewModel[] = [];

	public deleteInProgress: boolean = false;

	public loadedFlows: boolean = false;

	public loadedAnswers: boolean = false;

	public async mounted(): Promise<void> {
		if (this.flowReferences && this.flowReferences.length > 0) {
			await this.getFlows();
		}
		if (this.answerReferences && this.answerReferences.length > 0) {
			await this.getAnswers();
		}
	}

	public async getFlows(): Promise<void>  {
		this.flows = await this.loadFlows();
		this.loadedFlows = true;
	}

	public async getAnswers(): Promise<void> {
		this.answers = await this.loadAnswers();
		this.loadedAnswers = true;
	}

	public cancel(): void {
		this.$emit('cancel');
	}

	public get flowReferences(): IntentReferenceViewModel[] {
		return this.intent.references?.filter((r) => r.type === 'flow');
	}

	public get answerReferences(): IntentReferenceViewModel[] {
		return this.intent.references?.filter((r) => r.type === 'answer');
	}

	public getAnswerName(intentReference: IntentReferenceViewModel): string {
		const answer = this.answers?.find((a) => a.id === intentReference.id);
		return answer ? answer.title : '';
	}

	public getFlowName(intentReference: IntentReferenceViewModel): string {
		const flow = this.flows?.find((f) => f.id === intentReference.id);
		return flow ? flow.name : '';
	}

	public async confirmDelete(): Promise<void> {
		this.deleteInProgress = true;
		try {
			await this.deleteIntent(this.intent.id);
			Toast.showSuccess(`Successfully deleted intent ${this.intent.title}`);
			this.$emit('cancel');
		} catch (e: any) {
			Toast.showError(`Failed to delete intent: ${e.message}`);
		} finally {
			this.deleteInProgress = false;
		}
	}

	public isUnknownIntent(): boolean {
		return this.intent.id === 'None';
	}

	public isConfirmHidden(): boolean {
		return this.isUnknownIntent() || (this.intent.references && this.intent.references.length > 0);
	}

	public hasLoadedReferences(): boolean {
		return (this.answerReferences.length === 0 || this.loadedAnswers) && (this.flowReferences.length === 0 || this.loadedFlows);
	}
}
